<template>
  <div id="app">
    <transition name="fade" mode="out-in" appear>
      <router-view></router-view>
    </transition>
    <transition name="page-loader">
      <div v-if="showLoader" class="page-loader-wrapper">
        <div class="page-loader-bg"></div>
        <div class="page-loader-icon">
          <p>{{ $lang.loader }}</p><span></span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        showLoader: false,
        timeout: null
      }
    },
    mounted () {
      let self = this

      self.$bus.$on('LOADER.SHOW', () => {
        self.showLoader = true
        self.timeout = setTimeout(function () {
          self.showLoader = false
        }, 10000)
      })

      self.$bus.$on('LOADER.HIDE', () => {
        if (self.timeout !== null) {
          clearTimeout(self.timeout)
        }
        setTimeout(function () {
          self.showLoader = false
        }, 200) // TODO: En timeout här bara för att testa!!!!!
      })
    },
    name: 'app'
  }
</script>

<style lang="less">
  @import './assets/css/build.less';
</style>



// WEBPACK FOOTER //
// src/App.vue